import { isRejectedWithValue } from "@reduxjs/toolkit";
import type { Middleware } from "@reduxjs/toolkit";

// Actions

export const rtkQueryErrorLogger: Middleware = () => (next) => (action) => {
  if (isRejectedWithValue(action) && action.payload.data.statusCode >= 500) {
    // api.dispatch(setServiceError(true));
  }
  // Временно закомментировали, мешает авторизации через bloomreach
  // if (isRejectedWithValue(action) && action.payload.data.statusCode === 403) {
  //   localStorage.removeItem(STORAGE_AUTH_TOKEN);
  // }
  return next(action);
};
